import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-16 relative overflow-hidden">
      <div className="max-w-3xl mx-auto px-6 relative z-10 text-center">
        <h2 className="text-3xl sm:text-4xl font-bold text-white mb-5">
          About Work Play Save
          <div className="h-px w-24 bg-gradient-to-r from-purple-500 via-cyan-500 to-purple-500 mx-auto mt-4 rounded-full"></div>
        </h2>
        <p className="text-base text-gray-400 leading-relaxed mb-4">
          Work Play Save is an independent tech review site helping you find the best tools for gaming, streaming, and productivity without overspending. We research and compare products so you don&apos;t have to.
        </p>
        <p className="text-sm text-gray-500 leading-relaxed mb-8">
          Some links on this site are affiliate links. Purchases made through them support the site at no extra cost to you.
        </p>
        <Link
          to="/about"
          className="inline-flex items-center gap-2 px-6 py-3 border border-white/20 text-white rounded-lg font-semibold hover:border-cyan-400/50 hover:text-cyan-400 transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm text-sm"
        >
          Learn More
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}
